import { ReactElement } from 'react';

import {
   Notification,
   NotificationSize,
   NotificationType,
   StyledFlex,
   Text,
   TextSeparator,
   TextSeparatorType,
} from '@dreryk/react-components';
import { createInterpolatedTranslationKey } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

type ParticipantsLimitCellProps = {
   readonly minParticipants: number;
   readonly maxParticipants: number;
   readonly participantsCount: number;
};

export const ParticipantsLimitCell = (props: ParticipantsLimitCellProps): ReactElement => {
   return (
      <StyledFlex direction={'column'}>
         <TextSeparator separator={TextSeparatorType.SLASH}>
            <Text testId={'participantsCount'}>{props.participantsCount}</Text>
            <Text testId={'maxParticipants'}>{props.maxParticipants}</Text>
         </TextSeparator>
         {props.participantsCount < props.minParticipants ? (
            <Notification
               testId={'minParticipantsWarning'}
               type={NotificationType.WARNING}
               size={NotificationSize.SMALLER}
               label={createInterpolatedTranslationKey(translationKeys.minParticipantsWarning, {
                  minParticipantsCount: props.minParticipants,
               })}
            />
         ) : null}
      </StyledFlex>
   );
};
